
const crel = require('crel');

class AudioChannel {
    
    constructor (name, options)
    {
        this.name = name;
        this._setOptions.apply(this, options);
        this._init();
    }

    _setOptions(src, startLoad, loop, volumeRatio, muteDuration, defaultMuted)
    {
        this._startLoad = startLoad;
        this._audioSRC = src;       // ARRAY
        this._volumeRatio = volumeRatio || 1;
        this._muted = defaultMuted;
        this._loop = loop;
        this._muteDuration = muteDuration || 300;

    }

    _init()
    {
        this._failed = false;

        // Has not any display animation:
        this._shown = true;
        this._lastFixedProgress = -1;

        let obj = {};
        if (this._loop)
            obj.loop = 'loop';

        obj.preload = 'none';

        this._$cont = crel('div', { style: 'vizibility: hidden', id: 'audio_'+this.name }, [
            crel('audio', obj, '')
        ]);
        this._audio =  this._$cont.querySelector('audio');
        document.body.appendChild(this._$cont);

        if (this._audio.length < 1)
        {
            this._failed = true;
            return;
        }

        var i, s, src;
        for (i = 0; i < this._audioSRC.length; i++) {
            s = this._audioSRC[i];
            src = crel('source', { src: s.src, type: s.type  }, '');
            this._audio.appendChild(src);
        }
        this._src = [...this._audio.querySelectorAll('source')];
        this._addAudioListeners(true);
        if (this._startLoad)
        {
            try {
                this._audio.load();
            } catch (e) {
                this._errorHandler(e);
            }
        }

    }

    start()
    {
        if (this._started && this._loop) return;
        this._started = true;
       // if (this._to) clearTimeout(this._to);

        if (this._played) {
            this._audio.pause();
            this._audio.currentTime = 0;
            this._lastFixedProgress = -1;
        }

        if (this._startLoad || this._loaded) {

            if (!this._failed) {
                try {
                    if(this._playInformCMD)
                        this._playInformCMD.execute();
                    this._played = true;
                    this._audio.volume = this._volumeRatio;
                    this._audio.muted = this._muted;
                    this._audio.play();
                } catch (e) {
                    this._errorHandler(e);
                }
            }
        }
        else
        {
            try {
                this._audio.load();
            } catch (e) {
                this._errorHandler(e);
            }
        }
    }


    reset()
    {
        this._failed = false;
    }

    stop()
    {
        this._started = false;
        this._addAudioListeners(false);
        this._audio.pause();
    }

    unmute()
    {
        this._audio.muted = this._muted = false;
    }

    mute()
    {
        this._audio.muted = this._muted = true;
    }

    destroy()
    {
        //if (this._to) clearTimeout(this._to);
        this._$cont.remove();
    }


    _addAudioListeners (b) {

        if (b)
        {
            this._audio.dataset.playing = false;
            this.lr1 = _onCanplaythrough.bind(this);
            this.lr2 = _onCanplay.bind(this);
            this.lr3 = _onLoadstart.bind(this);
            this.lr4 = _onWaiting.bind(this);
            this.lr5 = _onUpdate.bind(this);
            this.lr6 = _onError.bind(this);
            this.lr7 = _onEnded.bind(this);
            this.lr8 = _onPlaying.bind(this);
            this._audio.addEventListener("canplaythrough", this.lr1);
            this._audio.addEventListener("canplay", this.lr2);
            this._audio.addEventListener("loadstart", this.lr3);
            this._audio.addEventListener("waiting", this.lr4);
            this._audio.addEventListener("timeupdate", this.lr5);
            this._audio.addEventListener("error", this.lr6);
            if (this._src) {
                for (let i = 0; i < this._src.length; i++)
                {
                    this._src[i].dataset.error = false;
                    this._src[i].addEventListener("error", this.lr6);
                }
            }
            this._audio.addEventListener("ended", this.lr7);
            this._audio.addEventListener("playing", this.lr8);

            if (this._audio.readyState > 3) {
                this._onCanplaythrough.apply(this);
            }
            else
            if (this._audio.readyState > 2) {
                this._onCanplay.apply(this);
            }
        }
        else
        {
            this._audio.removeEventListener("canplaythrough", this.lr1);
            this._audio.removeEventListener("canplay", this.lr2);
            this._audio.removeEventListener("loadstart", this.lr3);
            this._audio.removeEventListener("waiting", this.lr4);
            this._audio.removeEventListener("timeupdate", this.lr5);
            this._audio.removeEventListener("error", this.lr6);
            this._audio.removeEventListener("ended", this.lr7);
            if (this._src) {
                for (let i = 0; i < this._src.length; i++)
                {
                    this._src[i].removeEventListener("error", this.lr6);
                }
            }
            this._audio.removeEventListener("playing", this.lr8);
        }

        function _onCanplaythrough(evt) {
            //console.log(evt);
            this._loaded = true;
            _onCanplay.apply(this, [evt]);
        }

        function _onCanplay() {
            //console.log(evt)

            this._setCanplay();
        }

        function _onLoadstart() {
            //console.log(evt)
        }

        function _onUpdate() {
            var a;
            if (this._audio && this._audio.duration)
            {
                a = 100 * this._audio.currentTime / this._audio.duration;
                if (Math.floor(a / 25) > 0 && Math.floor(a / 25) > Math.floor(this._lastFixedProgress / 25))
                {
                    if (this._progressInformCMD)
                        this._progressInformCMD.execute(25 * Math.floor(a / 25));
                    this._lastFixedProgress = a;
                }
            }
        }

        function _onWaiting() {
            //console.log(evt);
            this._setBuffering();
        }

        function _onPlaying() {
            //console.log(evt);
            this._audio.dataset.playing = true;
            this._setPlaying();
        }

        function _onError(evt) {
            //console.log(evt);

            if (evt.currentTarget instanceof HTMLElement)
                evt.currentTarget.dataset.error = true;

            _checkErrors.apply(this);

        }

        function _checkErrors() {
            var i, src, n;
            for (i = 0, n = 0; i < this._src.length; i++)
            {
                src = this._src[i];
                if (src.dataset.error) n++;
            }
            if (!this._audio.dataset.playing && n >= this._src.length)
                this._errorHandler();
        }

        function _onEnded() {
            //console.log(evt)

            if (Math.floor(this._lastFixedProgress / 25) < 100 / 25)
            {
                if (this._progressInformCMD) this._progressInformCMD.execute(100);
                this._lastFixedProgress = 100;
            }

            this._completeHandler();
        }
    }

    _setCanplay () {
        if (this._failed) return;

        // TODO: ? new AudioCanplayCommand().execute();

        if (this._started)
        {

            if (!this._failed)
            {
                try {
                    if (this._playInformCMD)
                        this._playInformCMD.execute();
                    this._played = true;
                    this._audio.volume = this._volumeRatio;
                    this._audio.muted = this._muted;
                    this._audio.play();
                } catch (e) {
                    this._errorHandler();
                }
            }
        }
    }

    _setPlaying () {
        if (this._failed) return;
        // this._$cont.removeClass(this._bufferingClass);
    }

    _setBuffering () {
        if (this._failed) return;
        // this._$cont.addClass(this._bufferingClass);
    }

    _completeHandler () {
        if (this._failed) return;
        // this._$cont.removeClass(this._bufferingClass);

        // new AudioCompleteCommand().execute();
    }

    _errorHandler () { //console.log(evt)
        this._failed = true;
        //this._$cont.removeClass(this._bufferingClass);

        // new AudioErrorCommand().execute();
    }

    setPlayInformCommand (cmd) {
        this._playInformCMD = cmd;
    }

    setProgressInformCommand (cmd) {
        this._progressInformCMD = cmd;
    }

}

module.exports = AudioChannel;



// WEBPACK FOOTER //
// ./js/audioChannel.js